<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:default='props')
      bf-notice(@close='message = ""' :message='message')
      #merchants.view 
        header
          bf-wrapper
            h1 {{ $t('List of Merchants') }}
            p.invite
              router-link(:to='{ name: "referrals" }') {{ $t("Invite Merchants") }}
            span {{ $t("Didn’t find your favorite merchant here? You can invite them to join")}}
          
        section.merchants
          bf-wrapper
            merchant-card( v-for='item in merchants' :item='item' :key='item.id' :user='user' )
</template>

<script>
  import { View } from '@/mixins/view'
  import { db } from '@/main'
  import BaseCard from '@/components/base-card'
  import MerchantCard from '@/components/cards/merchant'
  import sort from '@/lib/sorters'

  export default {
    name: 'merchants.view',

    mixins: [View],

    components: {
      MerchantCard
    },

    data() {
      return {
        message: '',
        businesses: [],
        blacklisted: []
      }
    },

    firestore() {
      if ( this.user ) return {
        businesses: {
          ref: db.collection( 'businesses' ).orderBy( 'name' ).startAfter(''),
          resolve: sort.merchants
        },
        blacklisted: db.collection( 'customers' ).where( 'category', '==', 'Blacklist' ).where( 'account_id', '==', this.user.uid ),
      }
      else return {
        businesses: {
          ref: db.collection( 'businesses' ).orderBy( 'name' ).startAfter(''),
          resolve: sort.merchants
        }
      } 
    },

    computed: {
      merchants() {
        return this.filter( this.businesses, 'id' )
      }
    },

    watch: {
      user( curr, prev ) {
        if ( curr && curr.uid ) {
          this.$binding( 'blacklisted', db.collection( 'customers' ).where( 'category', '==', 'Blacklist' ).where( 'account_id', '==', curr.uid ) )
        }
      }
    },

    methods: {
      filter( docs, field='business_id' ) {
        return docs.filter( doc => !this.blacklisted.map( b => b.business_id ).includes( doc[field] ) )
      }
    }
  }
</script>

<style scoped lang='stylus'>
  #merchants
    .inputs
      .bf-wrapper
        padding-top 0
        padding-bottom 0
        .bf-flex
          flex-wrap wrap
          select
            width auto
            margin-left 0
          input
            margin-right 8px
            min-width 50%
          select, input
            border 1px solid rgba( 0 0 0 .1 )
            border-radius 17px
            padding 8px 24px
          @media( max-width: 359px )
            flex-direction column-reverse
            align-items flex-start
            input
              width 100%
              margin-top 16px
    .merchants .bf-wrapper
      display grid
      grid-template-columns repeat( auto-fill, minmax( 360px, 1fr ) )
      grid-gap 32px
      @media( max-width: 420px )
        grid-template-columns 1fr
  .invite
    width 120px
    color rgb(255 255 255)
    font-size 1em
    padding 10px 15px 
    text-align center
    background #1F4590
    border-radius 5px
    margin-top 20px
    margin-bottom 5px

</style>
